export default ({ dropdown }) => ({
  error: {},
  dark: {},
  disabled: {},
  input: {
    backgroundColor: dropdown.background,
    border: `1px solid ${dropdown.border}`,
    borderRadius: 2,
    boxSizing: 'border-box',
    color: dropdown.text,
    display: 'block',
    fontFamily: dropdown.fontFamily,
    fontSize: 14,
    height: 34,
    marginRight: -40,
    fontWeight: dropdown.fontWeight,
    padding: [4, 48, 4, 16],
    paddingRight: 40,
    textAlign: 'left',
    width: '100%',
    position: 'relative',
    cursor: 'pointer',
    '&$error': {
      '&$dark': {
        borderColor: dropdown.dark.errorBorderColor,
      },
      borderColor: dropdown.error.borderColor,
    },
    '&$dark': {
      backgroundColor: dropdown.dark.background,
      '&:focus': {
        outlineColor: dropdown.dark.darkFocusColor,
      },
      color: dropdown.dark.text,
    },
    '&$disabled': {
      backgroundColor: dropdown.disabledBg,
      color: dropdown.disabledText,
    },
    '&:focus': {
      outlineColor: dropdown.focusColor,
    },
  },
  selection: {
    '&$dark': {
      color: dropdown.dark.placeholderColor,
    },
    pointerEvents: 'none',
    position: 'absolute',
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 'calc(100% - 40px)',
    textAlign: 'left',
    padding: [3, 0, 7, 16],
    color: dropdown.text,
  },
  groupLabel: {
    padding: [2, 10, 4, 10],
    height: 50,
  },
  fitParentWidth: {
    display: 'inline-block',
    whiteSpace: 'normal',
  },
  caret: {
    '&$dark': {
      '& svg': {
        fill: dropdown.dark.iconFill,
      },
    },
    '&disabled': {
      display: 'none',
    },
    position: 'absolute',
    right: 10,
    top: 11,
    '& svg': {
      height: 16,
      width: 16,
      display: 'inherit',
      fill: dropdown.iconFill,
    },
  },
  toggle: {
    border: '0',
    background: 'transparent',
    width: 34,
    height: 34,
    position: 'absolute',
    top: 19,
    right: 3,
  },
  screenReaderLabel: {
    top: -1,
  },
});
